export default __webpack_public_path__ + "static/media/money-vector-man.bc603153.png";